import styled from 'styled-components';

export const UpdateCaseManagerText = styled.p`
  ${(props) => props.theme.newTypography.textStyleBody}
  color: ${(props) => props.theme.newPalette.neutral.N600};
  margin: 0;
  text-wrap: wrap;
`;

export const UpdateCaseManagerBoldText = styled.b`
  ${(props) => props.theme.newTypography.textStyleBodySemibold}
  color: ${(props) => props.theme.newPalette.neutral.N800};
`;
